import { navigateTo } from '../../../../../../common/frontend/route-utils.js'
import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import type { WorktimeCardPayload } from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'
import './worktime-card.css'

export const WorktimeCard = ({ data, lang }: { data: WorktimeCardPayload; lang: Language }) => {
    const c = t.portal.dashboard.cards.worktime

    if (data.projectCount === 0) {
        return <span className="portal-card__empty">{c.empty(lang)}</span>
    }

    return (
        <>
            <div className="portal-card__stat">
                <span className="portal-card__stat-label">{c.label(lang)}</span>
                <span className="portal-card__stat-value">{data.projectCount}</span>
            </div>
            {data.recentProjects.length > 0 && (
                <>
                    <hr className="portal-card__divider portal-card__divider--inner" />
                    <span className="portal-card__stat-label">{c.recentLabel(lang)}</span>
                    <ul className="portal-worktime-card__list">
                        {data.recentProjects.map((p) => (
                            <li key={p.id}>
                                <button
                                    type="button"
                                    className="portal-worktime-card__item"
                                    onClick={() => navigateTo('/me/worktime')}
                                >
                                    {p.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </>
    )
}
